// src/store/slices/navigationSlice.ts
import { createSlice } from '@reduxjs/toolkit';

// Define initial state
interface NavigationState {
  navigating: boolean;
}

const initialState: NavigationState = {
  navigating: false
};

// Create the slice
const navigationSlice = createSlice({
  name: 'navigation',
  initialState,
  reducers: {
    startNavigation: (state) => {
      state.navigating = true;
    },
    endNavigation: (state) => {
      state.navigating = false;
    }
  }
});

export const { startNavigation, endNavigation } = navigationSlice.actions;

export default navigationSlice.reducer;
